import { Box, TextField } from '@mui/material';
import styled from 'styled-components';

import { getTheme } from '@commons/utils/theme';

const theme = getTheme();

// Universal custom TextField with conditional styles
export const StyledNumberInput = styled(TextField)`
  width: 100%;
  height: 100%;

  & .MuiInput-root {
    height: 100%;
    background-color: transparent;
  }

  & .MuiInput-input {
    height: 100%;
    display: flex;
    align-items: center;
    color: ${theme.colors.greys.darkest};
    cursor: ${(props) => (props.disabled ? 'default' : 'text')};
    font-weight: 700;

    /* Prevent losing focus during navigation */
    &:focus {
      outline: none;
    }
  }

  & .MuiInput-underline:before {
    border-bottom: none;
  }

  & .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: none;
  }

  & .MuiInput-underline:after {
    border-bottom: none;
  }
`;

// Container for input with increment/decrement buttons
export const InputWithButtonsContainer = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;

  /* Target the MUI DataGrid cell container */
  .MuiDataGrid-cell & {
    overflow: visible !important;
  }
`;

// Increment/Decrement button
export const CustomButton = styled(Box)`
  position: absolute;
  width: 40px;
  height: 40px;
  background-color: ${({ disabled }) =>
    disabled ? theme.colors.greys.medium : theme.colors.greys.darkest};
  color: ${theme.colors.greys.lightest};
  border-radius: 8px;

  transition: background-color 0.2s ease;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  font-weight: bold;

  z-index: 1;

  &:hover {
    background-color: ${({ disabled }) =>
      disabled ? theme.colors.greys.medium : theme.colors.greys.dark};
  }

  &:active {
    background-color: ${({ disabled }) =>
      disabled ? theme.colors.greys.medium : theme.colors.greys.darker};
  }
`;

// Left button (decrement)
export const DecrementButton = styled(CustomButton)`
  left: -45px;
`;

// Right button (increment)
export const IncrementButton = styled(CustomButton)`
  right: -45px;
`;
